export default "__VITE_ASSET__KLueBSZ1__"